<template>
  <div class="lc lc-small">
    <div class="lc__top">
      <router-link :to="{ name: 'Main' }" class="page__header_title">
        ЭТО<b>ПРОСЧЕТ</b>
      </router-link>
      <div class="lc__name">{{ managerName }}</div>
    </div>

    <div class="goods" v-if="isAdmin">
      <div class="goods__nav">
        <template v-for="(item, id) in list">
          <button
            class="btn"
            :class="{ active: activeTab === id }"
            type="button"
            :key="id"
            @click="activeTab = id"
          >
            {{ item.name }}
            {{ item.role === "admin" ? " (ADMIN)" : "" }}
          </button>
        </template>
        <button
          class="btn"
          :class="{ active: activeTab === 'addForm' }"
          type="button"
          @click="activeTab = 'addForm'"
        >
          Добавить пользователя
        </button>
      </div>

      <div class="goods__tabs">
        <div
          v-for="(item, uid) in list"
          :key="uid"
          class="goods__tabs_item"
          :class="{ active: activeTab === uid }"
        >
          <h2 class="goods__title text-center">
            {{ item.name }} - <small>{{ item.email }}</small>
          </h2>
          <user-item :item="item" :uid="uid" @updateUsers="getUsers" />
        </div>
        <form
          class="goods__tabs_item"
          :class="{ active: activeTab === 'addForm' }"
          @submit.prevent="addUser"
        >
          <h2 class="goods__title text-center">Добавить пользователя</h2>
          <div class="form">
            <label class="page__label">
              <span class="page__text">Email</span>
              <input
                type="email"
                class="page__input"
                v-model="email"
                placeholder="Email"
              />
            </label>
            <label class="page__label">
              <span class="page__text">Пароль</span>
              <input
                type="text"
                class="page__input"
                v-model="password"
                placeholder="Пароль"
              />
            </label>
            <button
              class="btn btn-block"
              type="submit"
              :disabled="password.length <= 6"
            >
              Добавить
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import UserItem from "@/components/User-item";
import firebaseConfig from "../../firebaseConfig";

export default {
  name: "Users",
  components: { UserItem },
  data() {
    return {
      activeTab: "addForm" ?? "DXkZhma6dpVSgjcXPz6deNIxxCf1",
      list: {},
      email: "",
      password: ""
    };
  },
  created() {
    this.getUsers();
    this.secondaryApp = firebase.initializeApp(
      firebaseConfig,
      `secondary ${new Date().toString()}`
    );
  },
  computed: {
    managerName() {
      return this.$store.getters.manager?.name ?? "No name";
    },
    isAdmin() {
      return this.$store.getters["manager"]?.role === "admin";
    }
  },
  methods: {
    getUsers() {
      return firebase
        .database()
        .ref(`users`)
        .once("value")
        .then(res => {
          this.list = res.val() ?? [];
        });
    },
    addUser() {
      this.secondaryApp
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(({ user }) => {
          this.createNewUser(user.uid);

          this.secondaryApp.auth().signOut();
        })
        .catch(alert);
    },
    createNewUser(uid) {
      firebase
        .database()
        .ref(`users/${uid}`)
        .set({
          name: this.email,
          position: "position",
          phone: "phone",
          email: this.email,
          url: "url",
          role: "user"
        })
        .then(() => {
          this.getUsers();
        })
        .catch(alert);
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;
}
</style>
